import { MouseEvent } from 'react';

/**
 * The router's position in this tab's history, or null where it has stamped
 * none. The browser keeps it across a reload, so a page reached by clicking
 * through still reports its position once it is refreshed.
 */
export const getHistoryPosition = () => {
  const position: unknown = window.history.state?.idx;
  return typeof position === 'number' ? position : null;
};

/**
 * Whether one of this app's own pages sits behind the current entry. A page
 * opened straight from a typed URL, a bookmark or a new tab sits at position
 * zero, where stepping back would leave the app entirely.
 */
export const hasHistoryBehind = () => {
  const position = getHistoryPosition();
  return position !== null && position > 0;
};

/** Whether the browser should handle the click itself, opening a tab or a window. */
export const isModifiedClick = (event: MouseEvent) =>
  event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
